export default __webpack_public_path__ + "static/10-b5872e1198d089296f404cd5c43dbfd7.png";